import { render, staticRenderFns } from "./company-reports.vue?vue&type=template&id=8f6ea48a"
import script from "./company-reports.vue?vue&type=script&lang=js"
export * from "./company-reports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports